import { useLocation, useParams } from "react-router-dom";
import { ContentsTitle } from "src/components";
import MetaTag from "src/components/layout/MetaTag";
import { useQueryParams } from "src/hooks/useQueryParams";
import HistoryDetail from "src/components/histroy/HistoryDetail";
import useVisitor from "../hooks/useVisitor";
import BasicInfoDetail from "./BasicInfoDetail";
import { isMobilePath } from "src/utils";
import { PagePath } from "src/pages/product/details";
import ViewPC from "src/components/ViewPC";

const mobileTabs = [
  {
    label: "방문자",
    value: "basic",
    disabled: false,
  },
];
const tabs = [
  {
    label: "기본정보",
    value: "basic",
    disabled: false,
  },
  {
    label: "변경내역",
    value: "history",
    disabled: false,
  },
];

function VisitorDetail() {
  const { queryParams } = useQueryParams<{ tab?: string; reservationId?: string }>();
  const { pathname } = useLocation();

  // 현재 활성화 되어야하는 tab
  const activeTab = tabs.find((tab) => tab.value === queryParams?.tab) ?? tabs[0];

  const { contractApplyNumber, visitApplyNumber } = useParams();

  const { visitorGroup } = useVisitor({
    contractApplyNumber: contractApplyNumber,
    visitApplyNumber: visitApplyNumber,
  });

  const params = useParams();
  return (
    <div>
      <MetaTag />
      <ContentsTitle
        title="방문자 초대"
        tabs={isMobilePath(pathname) ? mobileTabs : tabs}
        activeTab={activeTab}
        detailInfo={visitApplyNumber ? [{ title: "방문신청번호", value: visitApplyNumber }] : undefined}
      />
      {isMobilePath(pathname) && (
        <div className="mobile-info-area">
          <p>ID : {visitApplyNumber}</p>
        </div>
      )}
      {activeTab.value === "basic" && <BasicInfoDetail />}
      {activeTab.value === "history" && visitorGroup?.contractVisitorGroupId && (
        <HistoryDetail identifier={{ contractVisitorGroupId: visitorGroup?.contractVisitorGroupId?.toString() }} />
      )}
    </div>
  );
}
export default VisitorDetail;
